export default __webpack_public_path__ + "static/custom-rules-175a3f2b0814eeb460af170afc4e6547.png";